import { z } from "zod";

export const customFieldSchema = z.object({
  defaultValues: z
    .array(z.object({ isSelected: z.boolean(), value: z.string() }))
    .optional()
    .nullable(),
  helpText: z.string().optional(),
  isActive: z.boolean().default(true),
  isMulti: z.boolean().default(false),
  isRequired: z.boolean().default(false),
  isVisibleAddressBook: z.boolean().default(false),
  isVisibleMobile: z.boolean().default(false),
  isVisibleOrder: z.boolean().default(false),
  name: z.string({ required_error: "Name is required." }),
  type: z.enum(["TEXT", "NUMBER", "DATE", "BOOLEAN", "DROPDOWN"]),
});
